export default "__VITE_ASSET__BjcZ_w2j__"